import {
  FaPencil,
  FaEllipsis,
  FaDisplay,
  FaList,
  FaCircleInfo,
  FaPlus,
  FaRegFloppyDisk,
  FaAddressBook,
  FaTrash,
  FaXmark,
  FaCheck,
  FaChevronDown,
  FaChevronUp,
  FaRotateRight,
  FaBarsProgress,
  FaCalendarDays,
} from "react-icons/fa6"

export default {
  edit: {
    label: "Edit",
    icon: FaPencil,
    description: "Modify the current item's properties and settings",
  },
  explore: {
    label: "Explore",
    icon: FaEllipsis,
    description: "View detailed information and related data for this item",
  },
  changeStatus: {
    label: "Change Status",
    icon: FaPencil,
    description: "Update the operational state or condition of this item",
  },
  changeLocation: {
    label: "Change Location",
    icon: FaPencil,
    description: "Update the physical location of the selected item",
  },
  monitor: {
    label: "Monitor",
    icon: FaDisplay,
    description: "Access real-time metrics and performance data",
  },
  log: {
    label: "View Log",
    icon: FaList,
    description: "Review historical events and activity records",
  },
  info: {
    label: "Info",
    icon: FaCircleInfo,
    description: "View detailed information and related data",
  },
  save: {
    label: "Save",
    icon: FaRegFloppyDisk,
    description: "Save the current item",
  },
  new: {
    label: "New",
    icon: FaPlus,
  },
  locationHistory: {
    label: "Location History",
    icon: FaAddressBook,
    description: "Select a previous location from the history",
  },
  delete: {
    label: "Delete",
    icon: FaTrash,
    description: "Delete the current item",
  },
  close: {
    label: "Close",
    icon: FaXmark,
    description: "Close the current action",
  },
  check: {
    label: "Check",
    icon: FaCheck,
    description: "Confirm the current action",
  },
  collapse: {
    label: "Collapse",
    icon: FaChevronUp,
    description: "Collapse the current action",
  },
  expand: {
    label: "Expand",
    icon: FaChevronDown,
    description: "Expand the current action",
  },
  refresh: {
    label: "Refresh",
    icon: FaRotateRight,
    description: "Refresh the current data",
  },
  addActivity: {
    label: "Add Activity",
    icon: FaBarsProgress,
    description: "Add a new activity to the current order",
  },
  calendar: {
    label: "Calendar",
    icon: FaCalendarDays,
    description: "View the calendar",
    variant: "primary",
  },
}
